module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[8]129.d582c82.woff2";